import { bunja } from 'bunja';
import { atom } from 'jotai';

import { mapTable } from '..';
import { Account_fromJsonValue } from '../../../model/prex.v2.r230522.tables.private_account';
import { r230522NormalSubSocketBunja } from '../../socket';
import { SubAccountIdScope } from '../../sub-account';

export const accountsBunja = bunja(() => {
  const { tablesAtom } = bunja.use(r230522NormalSubSocketBunja);

  const accountTableAtom = atom((get) => {
    const tables = get(tablesAtom);
    const accounts = tables['private/account'] || {};
    return mapTable(accounts, Account_fromJsonValue);
  });

  const accountsAtom = atom((get) => {
    const accountTable = get(accountTableAtom);
    return Object.entries(accountTable).map(([, value]) => value);
  });

  return { accountTableAtom, accountsAtom };
});
accountsBunja.debugLabel = 'accountsBunja';

export const accountBunja = bunja(() => {
  const subAccountId = bunja.use(SubAccountIdScope);
  const { subscribe } = bunja.use(r230522NormalSubSocketBunja);
  const { accountTableAtom } = bunja.use(accountsBunja);

  const accountAtom = atom((get) => {
    const accountTable = get(accountTableAtom);
    return subAccountId != null ? accountTable[subAccountId] : Object.values(accountTable)[0];
  });

  bunja.effect(() => {
    if (subAccountId == null) return;
    return subscribe('private/account', { rows: [`${subAccountId}`] });
  });

  return { accountAtom };
});
accountBunja.debugLabel = 'accountBunja';
